import * as Models from '../commonModels';

export class InventoryModel  {
  public InventoryId: number;
  public DocumentId: number;
  public DateFrom: Date;
  public DateTo: Date;
  public Description: string;
  public AddedByUser: string;
  public AddDate: Date;
  public Progress: number;
  public TotalDeposites: number;
  public TotalNotInventoredDeposites: number;
  public TotalInventoredDeposites: number;


  public IsStarted: boolean;
  public IsEnded: boolean;
  public IsWaiting: boolean;

  public IsReadOnly: boolean;
  public IsDeleteAvailable: boolean;
  public IsDateFromAvailable: boolean;
  public IsDateToAvailable: boolean;
  public IsEndAvailable: boolean;
  public IsStartAvailable: boolean;
  public IsSummaryUploadAvailable: boolean;

  public DoDelete: boolean;
  public DoEnd: boolean;
  public DoStart: boolean;
}

export class InventorySearchModel extends Models.SearchBaseModel {

}

export class InventoryGarageModel  {
  public Inventory_GarageId: number;
  public InventoryId: number;
  public DateFrom: Date;
  public DateTo: Date;
  public Description: string;
  public EndDate: Date;
  public DocumentId: number;
  public DocumentAddedByUser: string;
  public DocumentAddDate: Date;
}

export class InventoryDepositeModel {
  public InventoryId: number;
  public InventoryDepositeId: number;
  public DateFrom: Date;
  public DateTo: Date;
  public Description: string;
  public AddDate: Date;
  public AddedByUser: string;
  public DepositeInventoryStatus: string;
  public IsDepositeChanged: boolean;
}

export class InventoryDepositeChanges {
  public Tyre: string;
  public NewTyre: string;
  public TyreStateChanges: InventoriesDepositeTyreStateChange[];
}

export class InventoriesDepositeTyreStateChange {
  public IsValid: boolean;
  public TryePositionId: number;
  public TryePosition: string;
  public HeightTread: number;
  public TryeStateValue: string;
  public IsRim: boolean;
  public Dot: string;
  public Tyre: string;
  public IsNewValid: boolean;
  public NewHeightTread: number;
  public NewTryeStateValue: string;
  public NewIsRim: boolean;
  public NewDot: string;
  public NewTyre: string;
  public IsChangedHeightTread: boolean;
  public IsChangedTryeStateValue: boolean;
  public IsChangedIsRim: boolean;
  public IsChangedDot: boolean;
}
